import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { MyInfoSettingVersion } from '../../../../api/types';

const useMyinfoVersionOptions = () => {
    const { t } = useTranslation(['myInfoModuleDetails']);

    return useMemo(
        () => [
            { label: t('myInfoModuleDetails:options.versions.v3'), value: MyInfoSettingVersion.MyInfoV3 },
            { label: t('myInfoModuleDetails:options.versions.v5'), value: MyInfoSettingVersion.MyInfoV5 },
        ],
        [t]
    );
};

export default useMyinfoVersionOptions;
